var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wincare-old-list-component',{attrs:{"nomeTabellaRiferimento":_vm.nomeTabella,"utente":_vm.utente,"titolo":_vm.titolo}})}
var staticRenderFns = []

export { render, staticRenderFns }